import { t } from 'i18next';

import { SmallLoadingButton } from '~components/Order/ordersDispatchStyledComponents';

interface CSVImportButtonProps {
  entityDisplayName: string;
  isImporting: boolean;
  onImport: () => void;
  validRowCount: number;
}

export function CSVImportButton({
  entityDisplayName,
  isImporting,
  onImport,
  validRowCount,
}: CSVImportButtonProps) {
  return (
    <SmallLoadingButton
      color="brandV2Yellow"
      disabled={!validRowCount}
      loading={isImporting}
      onClick={onImport}
      variant="contained"
    >
      {t('csv_import_export.import_entity', { entity: entityDisplayName })}
    </SmallLoadingButton>
  );
}
